/**
 * 날짜·시각 표시 규칙.
 * 서버(API·DB)는 UTC 절대시각(ISO 문자열)으로 주고받고, 화면은 브라우저 시간대(예: Asia/Seoul)로 보여 준다.
 *  - 시각(timestamptz: createdAt·occurredAt 등) → fmtDate / fmtDateTime / fmtTime — 시간대 변환
 *  - 달력 날짜(date 컬럼: dueDate·effectiveDate 등, 서버가 'YYYY-MM-DDT00:00:00.000Z' 로 줌) → d10 — 변환 없이 날짜 부분만
 *  - 입력 기본값 → todayLocal / nowLocalInput — 브라우저 시간대의 오늘·지금
 */
type DateInput = string | number | Date | null | undefined;
const p2 = (n: number) => String(n).padStart(2, '0');
const toDate = (s: DateInput) => { if (s == null || s === '') return null; const d = s instanceof Date ? s : new Date(s); return Number.isNaN(d.getTime()) ? null : d; };
const ymd = (d: Date) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
const hm = (d: Date) => `${p2(d.getHours())}:${p2(d.getMinutes())}`;

/** 시각 → 브라우저 시간대의 날짜 'YYYY-MM-DD' */
export function fmtDate(s: DateInput, empty = '—') { const d = toDate(s); return d ? ymd(d) : empty; }
/** 시각 → 브라우저 시간대의 'YYYY-MM-DD HH:mm' */
export function fmtDateTime(s: DateInput, empty = '—') { const d = toDate(s); return d ? `${ymd(d)} ${hm(d)}` : empty; }
/** 시각 → 브라우저 시간대의 'HH:mm' */
export function fmtTime(s: DateInput, empty = '—') { const d = toDate(s); return d ? hm(d) : empty; }
/** 달력 날짜(date 컬럼) → 'YYYY-MM-DD'. 시간대 변환 없음 */
export const d10 = (s?: string | null, empty = '—') => (s ? s.slice(0, 10) : empty);
/** 브라우저 시간대의 오늘 'YYYY-MM-DD' (date 입력 기본값·기한 비교용) */
export const todayLocal = () => ymd(new Date());
/** Date → datetime-local 입력값 'YYYY-MM-DDTHH:mm' (브라우저 시간대) */
export const toLocalInput = (d: Date) => `${ymd(d)}T${hm(d)}`;
/** 지금 → datetime-local 입력 기본값 */
export const nowLocalInput = () => toLocalInput(new Date());
/** 브라우저 시간대 이름. 그리드 날짜 필터의 하루 경계를 서버가 이 시간대로 계산한다 */
export const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
